import React, { Component } from 'react'
import { get } from 'lodash'
import s from './LandingHeader.scss'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import { Container } from 'components/Layout'
import MobileMenu from 'components/MobileMenu'
import Popover from 'components/Popover'
import imgLogo from 'static/images/logo-white.png'
import IconMenu from 'components/Icons/Menu'
import IconUser from 'components/Icons/User'
import IconPhoneTalk from 'components/Icons/PhoneTalk'
import { Link } from 'react-router'

const MenuItem = ({ link }) =>
  link.sub ? (
    <Popover preferPlace="below" trigger="hoverDelay">
      <Link to={link.to} activeClassName={s.linkActive}>
        {link.name}
      </Link>
      <div className={s.popup}>
        {link.sub.map(item => (
          <Link key={item.name} to={item.to} activeClassName={s.linkActive}>
            {item.name}
          </Link>
        ))}
      </div>
    </Popover>
  ) : (
    <Link to={link.to} activeClassName={s.linkActive}>
      {link.name}
    </Link>
  )

export default class LandingHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
    }
  }
  toggleOpen = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }
  render() {
    const { atTop, cms, isLoggedIn } = this.props
    const { isOpen } = this.state
    const navItems = get(cms, 'navLinks', [])
    const halfLength = Math.ceil(navItems.length / 2)
    return (
      <div className={cn(s.header, s.filled)}>
        <Container className={cn(s.innerMobile, sLay['hide-gt-md'])}>
          <a onClick={this.toggleOpen}>
            <IconMenu active={isOpen} />
          </a>
          <span className={cn(s.empty, sLay['hide-xs'])} />

          <div className={cn(sLay.flex, sLay['layout-row'], sLay['layout-align-center-center'])}>
            <Link to="/" className={s.logo}>
              <img src={imgLogo} />
            </Link>
          </div>

          <Link className={cn(s['call-me'], sLay['hide-xs'])} to="tel:+611300688588">
            <IconPhoneTalk size={15} /> 1300 688 588
          </Link>

          <Link to={isLoggedIn ? '/dashboard' : '/login'} className={s.userButton}>
            <IconUser />
          </Link>
        </Container>

        <MobileMenu
          items={get(cms, 'navLinksMobile', [])}
          isOpen={isOpen}
          onClick={this.toggleOpen}
        />

        <Container className={cn(sLay['hide-xs'], sLay['hide-sm'], sLay['hide-md'])}>
          <div className={s.inner}>
            <div className={s.navDesktop}>
              {navItems.slice(0, halfLength).map(link => (
                <MenuItem link={link} key={link.name} />
              ))}
            </div>
            <Link to="/" className={s.logo}>
              <img src={imgLogo} />
            </Link>
            <div className={s.navDesktop} style={{ position: 'relative' }}>
              {navItems.slice(halfLength).map(link => (
                <MenuItem link={link} key={link.name} />
              ))}

              <Link to="tel:+611300688588">
                <IconPhoneTalk size={15} /> 1300 688 588
              </Link>

              <span className={s.actionButtonContainer}>
                <Link to={isLoggedIn ? '/dashboard' : '/login'} className={s.actionButton}>
                  {isLoggedIn ? 'Dashboard' : 'Sign in'}
                </Link>
              </span>
            </div>
          </div>
        </Container>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingHeader/LandingHeader.jsx